export var ElementTypes;
(function (ElementTypes) {
    ElementTypes["ELEMENT"] = "element";
    ElementTypes["TEXT"] = "text";
    ElementTypes["WORD"] = "word";
})(ElementTypes || (ElementTypes = {}));
const wordRegex = /((?:\w|[’'"-—.]\w)+)/;
const quotationRegex = /((?:["]\w)+)/;
export function recursiveTransformElements(htmlDef, startingIndex = -1) {
    var _a, _b, _c, _d, _e, _f;
    const clonedHtml = Object.assign({}, htmlDef);
    let index = startingIndex;
    if (htmlDef.type == ElementTypes.ELEMENT) {
        clonedHtml.elements = (_a = clonedHtml.elements) === null || _a === void 0 ? void 0 : _a.reduce((elements, element) => {
            const { htmlDef: newHtmlDef, index: newIndex } = recursiveTransformElements(element, index);
            index = newIndex;
            const returnElements = Array.isArray(newHtmlDef) ? newHtmlDef : [newHtmlDef];
            return elements.concat(returnElements);
        }, []);
    }
    else if (htmlDef.type == ElementTypes.TEXT) {
        let previousWord;
        const wordArray = (_d = (_c = (_b = clonedHtml.text) === null || _b === void 0 ? void 0 : _b.split(wordRegex)) === null || _c === void 0 ? void 0 : _c.reduce((agg, word) => {
            const isWord = wordRegex.test(word);
            if (quotationRegex.test(word) && !wordRegex.test(previousWord)) {
                agg = agg.concat([
                    {
                        type: ElementTypes.TEXT,
                        text: '"',
                        index: ++index
                    },
                    {
                        type: ElementTypes.WORD,
                        text: word.split('"')[1],
                        index: index
                    }
                ]);
            }
            else {
                agg.push(word
                    ? {
                        type: isWord ? ElementTypes.WORD : ElementTypes.TEXT,
                        text: word,
                        index: isWord ? ++index : index
                    }
                    : undefined);
            }
            previousWord = word;
            return agg;
        }, [])) === null || _d === void 0 ? void 0 : _d.filter(Boolean);
        return { htmlDef: wordArray !== null && wordArray !== void 0 ? wordArray : [], index: (_e = clonedHtml.index) !== null && _e !== void 0 ? _e : index };
    }
    return { htmlDef: clonedHtml, index: (_f = clonedHtml.index) !== null && _f !== void 0 ? _f : index };
}
export function transformElements(html) {
    if (!html)
        return { type: ElementTypes.ELEMENT, name: 'h2', index: 0 };
    const { htmlDef: clonedHtml } = recursiveTransformElements(html);
    return clonedHtml;
}
export function getHtmlText(htmlString) {
    const span = document.createElement('span');
    span.innerHTML = htmlString;
    return span.textContent || span.innerText;
}
